module.exports = __webpack_public_path__ + "img/zat_logo.deff60a3.png";